import { Account } from '..'
import { Billing } from '../billing/billing'
import { PerformanceMode } from '../targets'

export namespace Domain {
    export type ID = number

    // Note: this corresponds to the response of getDomainList, not getDomainInfo (not used yet)
    export interface Info {
        domain_id: Domain.ID
        account_id: Account.ID
        account_group_id: number | null
        manager_user_id: number | null
        domain_name: string
        color_preference: string
        adwords_client_customer_id: string
        adwords_timezone: string
        last_checked_eligibility: Date
        currency: string
        currency_code: Billing.CurrencyCode
        current_month_spend: number
        last_visited: Date | null
        row_added: Date
        status: 'active' | 'inactive'
        '30d_cost': number
        '30d_cost_usd': number
        '30d_conversions': number
        budget: number
        is_grant: boolean
        budget_sort_order_value?: number
        budget_bar: BudgetBar
        tasks_available: number
        tasks_completed: number
        tasks_dismissed: number
        legacy: true
        performance_mode: PerformanceMode
        connection_email?: string
        accountSetupSeen: boolean
    }

    export type InfoV2 = Omit<Domain.Info, 'budget_bar' | 'budget_sort_order_value'>

    export interface BudgetBar {
        budget: number
        budget_variance: number
        has_budget_auto_pause: boolean
        actual_spend: number
        has_budget: boolean
        display_difference: number
        month_progress_percentage: number
        month_spent_percentage: number
        status: BudgetStatus
        budget_sort_order_value?: number
    }
    export interface Logo {
        logo_filename: string
        domain_id: number
    }

    export enum BudgetStatus {
        FAR_OVER = 'far_over',
        OVER = 'over',
        GOOD = 'good',
        UNDER = 'under',
        FAR_UNDER = 'far_under',
        TOO_EARLY = 'too_early',
        INVALID = 'invalid',
    }

    export interface ListMetrics {
        sparkline_data: {
            cost_sparkline: ListMetricsSparkline
            conversion_sparkline: ListMetricsSparkline
            conversion_value_sparkline: ListMetricsSparkline
        }
        budget_bar: Domain.BudgetBar
        legacy: boolean
    }

    export interface ListMetricsSparkline {
        points: { x: number; y: number }[]
        thirty_day_total: number
        delta: number
    }
}
